import { usersApi } from '@app/services'

import { FetchChatUsersResponse } from './types'

export const fetchChatUsers = async (
  userIds: number[]
): Promise<FetchChatUsersResponse['users']> => {
  if (userIds.length === 0) {
    return []
  }

  const { data } = await usersApi.post<FetchChatUsersResponse>(
    '/users/ids',
    { userIds },
    {
      params: {
        mode: 'chat',
      },
      headers: {
        'Accept-Language': 'all',
      },
    }
  )

  return data.users
}
